import { useResponsive } from '../../../hooks/useResponsive';
import HowItWorksDesktop from './HowItWorksDesktop';
import HowItWorksMobile from './HowItWorksMobile';

const HowItWorksSection = ({ scrollY, parentRef }) => {
  const { isMobile } = useResponsive();

  if (isMobile) {
    return <HowItWorksMobile />;
  }

  return <HowItWorksDesktop scrollY={scrollY} parentRef={parentRef} />;
};

export default HowItWorksSection;
